import React, { FunctionComponent, useState } from 'react';

import { PanelRow } from './DependencyViewAccordion';

interface DependencyViewAccordionPanelProps {
  panelRow: PanelRow;
}

export const DependencyViewAccordionPanel: FunctionComponent<DependencyViewAccordionPanelProps> =
  ({ panelRow }) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasDependentFields = !!panelRow.dependentRows?.length;

    return (
      <>
        <tr className="dcf-accordion-panel" role='grid'>
          <td onClick={(): void => setIsOpen(!isOpen)} role='gridcell'>
            <div className='dcf-accordion-panel-caret-cell'>
              {hasDependentFields ?
                <span
                  aria-hidden="true"
                  className={`${isOpen ? 'bff-caret-down' : 'bff-caret-up'}`}
                /> : <span className="no-caret" />}
              <span className="dcf-accordion-panel-rowCell">{panelRow.customFieldName}</span>
            </div>
          </td>
          <td>
            {hasDependentFields &&
              panelRow.dependentRows[0].value && (
                <span className="dcf-accordion-panel-rowValue">
                  <span className="bff-connector" />
                  <span>{panelRow.dependentRows[0].value}</span>
                </span>)}
          </td>
          <td className="col-width-50">
            {hasDependentFields &&
              panelRow.dependentRows[0].dependentCustomFields?.map((dcf) =>
                <span key={dcf} className="dcf-accordion-panel-rowCell">{dcf} </span>)}
            <span className='bff-ellipsis' />
          </td>
        </tr>
        {
          isOpen &&
          panelRow.dependentRows?.map((row, index) => (
            index !== 0 && (
              <tr key={row.value} className="dcf-accordion-panel dcf-row">
                <td />
                <td>
                  <span className="dcf-accordion-panel-rowValue">
                    <span className="bff-connector" />
                    <span>{row.value}</span>
                  </span>
                </td>
                <td className="col-width-50">
                  {row.dependentCustomFields?.map((dcf) =>
                    <span key={dcf} className="dcf-accordion-panel-rowCell">{dcf} </span>)
                  }
                  <span className='bff-ellipsis' />
                </td>
              </tr>
            )
          ))
        }
      </>
    );
  };
